export const FETCH_FOOTER_REQUEST = 'FETCH_FOOTER_REQUEST'
export const FETCH_FOOTER_SUCCES = 'FETCH_FOOTER_SUCCES'
export const FETCH_FOOTER_ERROR = 'FETCH_FOOTER_ERROR'



// WEBPACK FOOTER //
// ./src/constants/Footer.js